import { styled } from "@mui/material";

export const ParentContainer = styled("div")(({ theme }) => ({
    // background: `url("/assets/images/hospitalLogin4.jpg") no-repeat center center fixed`,
    background: "#f4f4ee",
    minHeight:"100%",
    position: "relative",
    boxSizing: "border-box",
}))

export const LoginContainer = styled("div")(({ theme }) => ({
    display: "flex",
    width: "100%",
    height: "100%",
    [theme.breakpoints.down("md")]: {
        flexDirection: "column",
    },
    position:"relative",
  }));
  
 export const LeftSide = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    flex: "1 1 0",
    gap: "5rem",
    backgroundColor: "#fff",
    padding: "4rem",
    [theme.breakpoints.down("sm")]: {
        padding: "1rem",
    },
    boxShadow: "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset"
  }));
  
 export const RightSide = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    flex: "1 1 0",
    // background: "radial-gradient(circle, #181a1c 50%, #000 100%)",
    background: `url("/assets/images/hospitalLogin3.svg") no-repeat center center`,
    padding: "4rem",
    [theme.breakpoints.down("sm")]: {
        padding: "1rem",
    }
    
  }));
  